var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96097 2.92884C6.26968 -0.34413 11.2987 -0.872937 15.1645 1.33733C15.7017 1.64442 15.8853 2.32407 15.575 2.85536C15.2645 3.38666 14.5774 3.56841 14.0404 3.26132C11.0329 1.54188 7.12097 1.95653 4.5495 4.50021C1.47887 7.53766 1.47887 12.4624 4.5495 15.4998C7.12097 18.0434 11.0329 18.4581 14.0404 16.7386C14.5774 16.4316 15.2645 16.6133 15.575 17.1446C15.8853 17.676 15.7017 18.3556 15.1645 18.6627C11.2987 20.8729 6.26968 20.3441 2.96097 17.0712C-0.98699 13.1659 -0.98699 6.83413 2.96097 2.92884ZM17.178 5.88094C17.6166 5.44701 18.3279 5.44701 18.7665 5.88094L20.8908 7.98229C21.0913 8.18063 21.2865 8.37363 21.4384 8.55052C21.6051 8.74486 21.7844 8.99142 21.8901 9.31331C22.0366 9.75965 22.0366 10.2404 21.8901 10.6867C21.7844 11.0087 21.6051 11.2552 21.4384 11.4495C21.2865 11.6263 21.0913 11.8195 20.8908 12.0177L18.7665 14.119C18.3279 14.5529 17.6166 14.5529 17.178 14.119C16.7393 13.6852 16.7393 12.9816 17.178 12.5477L18.6302 11.1111H10.1094C9.489 11.1111 8.98611 10.6137 8.98611 9.99999C8.98611 9.38631 9.489 8.88886 10.1094 8.88886H18.6302L17.178 7.45231C16.7393 7.01839 16.7393 6.31486 17.178 5.88094Z",
    fill: "url(#paint0_linear_6573_1868)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6573_1868",
    x1: 5.45892,
    y1: 1.20038,
    x2: 14.8485,
    y2: 19.0899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutActive);
export default __webpack_public_path__ + "static/media/logoutActive.15a21dc6877cc1bcd411e6b75eb2064b.svg";
export { ForwardRef as ReactComponent };